import React from 'react';
import Styles from './styles.module.scss';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type Align = 'left' | 'center' | 'right';

interface TitleProps {
  tag: HeadingTag;
  children: React.ReactNode;
  subTitle?: React.ReactNode;
  className?: string;
  align?: Align;
}

function cx(...parts: Array<string | undefined | false>) {
  return parts.filter(Boolean).join(' ');
}

const Title: React.FC<TitleProps> = ({
  tag: Tag,
  children,
  subTitle,
  className,
  align = 'left',
}) => {
  return (
    <div className={cx(Styles.wrapper, Styles[`align-${align}`], className)}>
      {subTitle && <p className={Styles.sub}>{subTitle}</p>}
      <Tag className={Styles.index}>{children}</Tag>
    </div>
  );
};

export default Title;
